import { Plus, Maximize2 } from 'lucide-react';
import { useState } from 'react';
import { PackagesTableContent } from './PackagesTableContent';
import { PackagesTableModal } from './PackagesTableModal';

export const PackagesTable = ({ declarationIndex, itemIndex, isSpanish, item, editableData, setEditableData, setIsDirty }) => {
  const [embalajesModalOpen, setEmbalajesModalOpen] = useState(false);
  const [currentEmbalajeIndex, setCurrentEmbalajeIndex] = useState(null);
  const [isExpandModalOpen, setIsExpandModalOpen] = useState(false);

  return (
    <div className="packages-table">
      <div className="form-group flex-1 mt-12 !mb-0 flex justify-between flex-row items-center">
        <label htmlFor="companyName" className="!mb-0 !text-sm !opacity-100 !text-xl font-semibold uppercase">
          {!isSpanish ? "Packages" : "Embalajes"} ({item.embalajes?.length || 0})
        </label>
        <div className="flex gap-2 items-center">
          <button
            className="py-1 text-xs flex items-center gap-1"
            onClick={() => {
              const updatedData = [...editableData];
              if (!updatedData[declarationIndex].partidas[itemIndex].embalajes)
                updatedData[declarationIndex].partidas[itemIndex].embalajes = [];
              updatedData[declarationIndex].partidas[itemIndex].embalajes.push({
                tipo: "",
                cantidad: "",
                cantidad_restante: "",
                piezas: "",
                es_interno_o_externo: "",
                marcas: [],
              });
              setEditableData(updatedData);
              setIsDirty(true);
            }}
          >
            <Plus className={`size-4`} />
            {isSpanish ? "Agregar Embalaje" : "Add Package"}
          </button>
          {/* Expand View button */}
          <button
            className="bg-default text-white rounded-full py-1.5 px-3 text-xs flex items-center gap-1"
            onClick={() => setIsExpandModalOpen(true)}
            title={!isSpanish ? "Expand View" : "Vista Expandida"}
          >
            <Maximize2 className="size-3 stroke-white" />
            {!isSpanish ? "Expand View" : "Vista Expandida"}
          </button>
        </div>
      </div>
      <PackagesTableContent
        declarationIndex={declarationIndex}
        itemIndex={itemIndex}
        isSpanish={isSpanish}
        item={item}
        editableData={editableData}
        setEditableData={setEditableData}
        setIsDirty={setIsDirty}
        embalajesModalOpen={embalajesModalOpen}
        setEmbalajesModalOpen={setEmbalajesModalOpen}
        currentEmbalajeIndex={currentEmbalajeIndex}
        setCurrentEmbalajeIndex={setCurrentEmbalajeIndex}
      />
      <PackagesTableModal
        isOpen={isExpandModalOpen}
        onClose={() => setIsExpandModalOpen(false)}
        declarationIndex={declarationIndex}
        itemIndex={itemIndex}
        isSpanish={isSpanish}
        item={item}
        editableData={editableData}
        setEditableData={setEditableData}
        setIsDirty={setIsDirty}
      />
    </div>
  )

}